import TitleBox from "@/components/title.vue";
import RealCase from "@/components/real-case.vue";
import Product from "@/components/product.vue";
export default {
  name: "PrintCollege",
  components: {
    TitleBox,
    RealCase,
    Product
  },
  data() {
    return {
      dataList: [
        { name: "投放高校", num: "200", unit: "+" },
        { name: "多拉会员", num: "170", unit: "万+" },
        { name: "多拉订单", num: "5100", unit: "万+" },
        { name: "打印纸张", num: "20", unit: "亿+" }
      ],
      carouselList: [
        require("@/assets/convenience/live1.png"),
        require("@/assets/convenience/live2.png"),
        require("@/assets/convenience/live3.png")
      ]
    };
  },
  computed: {},
  methods: {
    toProductListPage() {
      this.$router.push("/product/list?type=college");
    }
  }
};
